import { render, staticRenderFns } from "./PersonsListModal.vue?vue&type=template&id=2b9525fc&scoped=true&"
import script from "./PersonsListModal.vue?vue&type=script&lang=ts&"
export * from "./PersonsListModal.vue?vue&type=script&lang=ts&"
import style0 from "./PersonsListModal.vue?vue&type=style&index=0&id=2b9525fc&lang=scss&scoped=true&"
import style1 from "./PersonsListModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9525fc",
  null
  
)

export default component.exports